// Widgets

jQuery(document).ready(function ($) {

  $('.c-widget-droppod--title').on('click', function() {
      $(this).stop().toggleClass('active');
      $(this).stop().next('ul').toggleClass('active');
  });

  $('.c-get-help--btn').on('click', function() {
    $(this).toggleClass('active');
    $(this).next('.c-widget-text').toggle();
  });

});

$('.c-sidebar-nav--mobile').on('click', function () {
    $(this).toggleClass('active');
    $(this).find('#SideNavMobileMenu').toggleClass('active');
});

// Form Validation

$('.formVal input').on('focus', function () {
    $(this).prev('span[style="display: inline;"]').css('display', 'none');
});

// search results count

$(".results-count").prependTo(".SearchResults");